import React from 'react';
import HeroContainer from './HeroContainer';
import './styles/Hero.css';

const Hero = () => {

    return (
        
        <section className = "section-hero">
            <div className="hero">
                <HeroContainer />
            </div>
        </section>
    )

}

export default Hero;